import React from 'react';
import SEO from '../components/SEO';

const SMSPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO title="SMS & Text Messaging Policy | CTHomeremodels.com" description="SMS text messaging terms and conditions for Visser General Construction LLC." />
      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-3xl font-bold mb-8 text-[#5c0701]">SMS / Text Messaging Policy</h1>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6 text-sm text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">1. Consent</h2>
            <p>By providing your phone number and opting in, you consent to receive text messages from <strong>Visser General Construction LLC</strong> ("Company") at the phone number you provided. Consent is not a condition of purchase. You can opt out at any time.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">2. Message Types</h2>
            <p>Messages may include:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Appointment confirmations and reminders</li>
              <li>Project updates and status notifications</li>
              <li>Estimate follow-ups</li>
              <li>Promotional offers and seasonal specials</li>
              <li>Service announcements</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">3. Message Frequency</h2>
            <p>Message frequency varies. You may receive up to <strong>10 messages per month</strong>. Message and data rates may apply.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">4. Opt-Out</h2>
            <p>To stop receiving messages at any time, reply <strong>STOP</strong> to any message. You will receive a confirmation and no further messages will be sent.</p>
            <p className="mt-2">You may also contact us at <strong>(203) 604-3202</strong> to request removal.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">5. Help</h2>
            <p>For help, reply <strong>HELP</strong> to any message, or contact us at <strong>(203) 604-3202</strong>.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">6. Privacy</h2>
            <p>We do not sell, share, or distribute your phone number to third parties. Your information is used solely for communicating with you about our services.</p>
            <p className="mt-2">For our full privacy policy, visit <a href="/privacy" className="text-[#3a87fe] hover:underline">cthomeremodels.com/privacy</a>.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-2 text-gray-900">7. Carrier Disclaimer</h2>
            <p>Carriers are not liable for delayed or undelivered messages. Message and data rates may apply. Check with your mobile carrier for details on your plan.</p>
          </section>

          <section className="border-t pt-6">
            <p className="text-xs text-gray-400">
              <strong>Visser General Construction LLC</strong><br />
              42 Gay St, Meriden, CT 06450<br />
              Phone: (203) 604-3202<br />
              Website: cthomeremodels.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SMSPolicyPage;
